import React from 'react'
import './Footer.css'
import online_shopping from '../Assets/online_shopping.png'
import instagram from '../Assets/instagram.png'
import facebook from '../Assets/facebook.png'
import tiktok from '../Assets/tiktok.png'
import whatsapp from '../Assets/whatsapp.png'
import linkedin from '../Assets/linkedin.png'

export const Footer = () => {
  return (
    <div className='footer'>
      <div className="footer-logo">
        <img src={online_shopping} alt="online-shopping" width={60} height={60} />
        <p>MADORA</p>
      </div>
      <ul className="footer-links">
        <li>Company</li>
        <li>Products</li>
        <li>Offices</li>
        <li>About</li>
        <li>Contact</li>
      </ul>

      <div className="footer-social-icons">
        <div className="footer-icon-containers">
          <a
            href="https://www.instagram.com/mamadorafoodandspices?igsh=b2pyeHd6dG05bzhs"
            rel="noopener noreferrer">
            <img src={instagram} alt="instagram" width={60} height={60} />
          </a>
        </div>

        <div className="footer-icon-containers">
          <a
            href="https://www.facebook.com/dorasfoodandspices"
            rel="noopener noreferrer">
            <img src={facebook} alt="Facebook" width={60} height={60} />
          </a>
        </div>

        <div className="footer-icon-containers">
          <a
            href="https://www.tiktok.com/@mamadorafood?_t=8rc1KfS9aWF&_r=1"
            rel="noopener noreferrer">
            <img src={tiktok} alt="tikTok" width={60} height={60} />
          </a>
        </div>

        <div className="footer-icon-containers">
          <a href="https://wa.me/+2348130833875" rel="noopener noreferrer">
            <img src={whatsapp} alt="whatsapp" width={60} height={60} />
          </a>
        </div>

        <div className="footer-icon-containers">
          <a
            href="https://www.linkedin.com/company/mama-dora/"
            rel="noopener noreferrer">
            <img src={linkedin} alt="linkedIn" width={60} height={60} />
          </a>
        </div>






      </div>
      <div className="footer-copyright">
        <hr />
        <p>copyright @2026 All Right Reserved</p>
      </div>
    </div>
  )
}



export default Footer;
